import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const changeEmail = (userId, email) =>
  call(websocketFetch, 'change_email', {
    user_id: userId,
    new_email: email,
  });
